import setAiPrompt from './setAiPrompt';
import setNoteAssist from './setNoteAssist';

export default {
  setAiPrompt,
  setNoteAssist,
};
